
(() => {
  const DRAWER = '#CartPopup';
  const ITEM = '.upcart-product-item';
  const PROP = '.upcart-item-property';
  const ANCHOR = '.upcart-item-properties-anchor-after';
  const PREVIEW = 'tee-preview-design';
  const RE = /_customization_id\s*:\s*([a-z0-9-]{8,})/i;

  function getId(item) {
    for (const el of item.querySelectorAll(PROP)) {
      const t = (el.textContent || '').trim();
      const m = t.match(RE);
      if (m && m[1]) return m[1];
      const strong = el.querySelector('strong');
      if (strong && /_customization_id/i.test(strong.textContent || '')) {
        const span = el.querySelector('span');
        if (span && span.textContent) return span.textContent.trim();
      }
    }
    return '';
  }

  function addPreview(item) {
    const id = getId(item);
    if (!id) return;
    if (item.querySelector(`.${PREVIEW}[data-customization-id="${CSS.escape(id)}"]`)) return;
    const host = document.createElement('div');
    host.className = PREVIEW;
    host.setAttribute('data-customization-id', id);
    const anchor = item.querySelector(ANCHOR);
    if (anchor) anchor.insertAdjacentElement('afterend', host);
    else item.appendChild(host);
  }

  function scan(root = document) {
    root.querySelectorAll(ITEM).forEach(addPreview);
  }

  function watch(drawer) {
    const mo = new MutationObserver(muts => {
      muts.forEach(m => {
        m.addedNodes.forEach(n => {
          if (n.nodeType !== 1) return;
          if (n.matches?.(ITEM)) addPreview(n);
          n.querySelectorAll?.(ITEM).forEach(addPreview);
        });
      });
    });
    mo.observe(drawer, { childList: true, subtree: true });
    scan(drawer);
  }

  function init() {
    const d = document.querySelector(DRAWER);
    if (d) return watch(d);
    const mo = new MutationObserver(() => {
      const x = document.querySelector(DRAWER);
      if (x) { mo.disconnect(); watch(x); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// English product bases keep their original option values for fulfilment.
// Translate only their displayed Teeinblue labels on German storefront pages.
(() => {
  const locale = document.documentElement.lang.split('-')[0];
  const savingText = {de: 'Spare', en: 'Save', fr: 'Économise', nl: 'Bespaar', es: 'Ahorra', it: 'Risparmia'}[locale];
  if (!savingText) return;
  const labels = new Map(locale === 'de' ? [
    ['Quantity', 'Menge'],
    ['Upload a photo of your dog or pet:', 'Lade ein Foto deines Hundes oder Haustiers hoch:'],
    ['Name of your dog or pet:', 'Name deines Hundes oder Haustiers:'],
    ['Baby Blue', 'Babyblau'],
    ['Natural', 'Natur'],
    ['Black', 'Schwarz'],
    ['White', 'Weiß']
  ] : locale === 'en' ? [["Anzahl der Fotos", "Number of photos"], ["Dein Foto:", "Your photo:"], ["Dein Name oder Text:", "Your name or text:"], ["Dein Text oder Auto:", "Your text:"], ["Farbe der Schrift", "Lettering color"], ["Stil", "Style"], ["Boyfriend oder Husband", "Boyfriend or Husband"], ["GIRLFRIEND oder WIFEY", "Girlfriend or Wifey"], ["Text vorne:", "Front design:"], ["Lade ein Foto hoch:", "Upload a photo:"], ["Euer Jahrestag:", "Your anniversary:"], ["Dein gew\u00fcnschtes Foto:", "Your photo:"], ["Spruch oben:", "Top text:"], ["Der gew\u00fcnschte Name:", "Name:"], ["Datum:", "Date:"], ["Schwarz", "Black"], ["Wei\u00df", "White"], ["Rot", "Red"], ["Bordeaux", "Burgundy"], ["Blau", "Blue"], ["Gr\u00fcn", "Green"], ["Beige", "Beige"], ["Gelb", "Yellow"], ["Foto 1:", "Photo 1:"], ["1 Foto", "1 photo"], ["Foto 2:", "Photo 2:"], ["2 Fotos", "2 photos"], ["Foto 3:", "Photo 3:"], ["3 Fotos", "3 photos"], ["Foto 4:", "Photo 4:"], ["4 Fotos", "4 photos"], ["Foto 5:", "Photo 5:"], ["5 Fotos", "5 photos"], ["Foto 2 (unten):", "Photo 2 (bottom):"], ["Foto 1 (oben):", "Photo 1 (top):"], ["Eure Namen:", "Your names:"], ["Jahr:", "Year:"], ["W\u00e4hle dein Datum aus:", "Choose your date:"], ["Gr\u00f6\u00dfe", "Size"], ["Farbe", "Color"], ["Menge", "Quantity"], ["Dein Name:", "Your name:"], ["Euer Name:", "Your name:"], ["Euer Text:", "Your text:"], ["Euer Foto:", "Your photo:"], ["Wähle dein Foto aus:", "Choose your photo:"], ["Dein gewünschter Name...", "Your name..."], ["Dein gewünschter Text...", "Your text..."], ["Gib deinen gewünschten Text ein...", "Enter your text..."], ["Lila Blau 2", "Purple / Blue"], ["Rosa", "Pink"], ["Orange Rot", "Orange / Red"], ["Türkis", "Turquoise"], ["Burgund", "Burgundy"]] : []);
  const selector = '#tee-artwork-form .tee-field__heading > span:not(.tee-asterisk), .tee-quantity .tee-field__title, .tee-radio-label--color > span, #tee-artwork-form .tee-clipart-label__text, .tee-price--saving-text';
  let scheduled = false;
  function translateLabels() {
    scheduled = false;
    document.querySelectorAll(selector).forEach(label => {
      const translation = label.matches('.tee-price--saving-text') ? savingText : labels.get(label.textContent.trim());
      if (translation && label.childElementCount === 0 && label.textContent.trim() !== translation) label.textContent = translation;
      if (translation && label.closest('.tee-clipart-label')) {
        const option = label.closest('.tee-clipart-label');
        option.dataset.title = translation;
        const image = option.querySelector('img');
        if (image) image.alt = translation;
      }
    });
    if (locale === 'en') document.querySelectorAll('#tee-artwork-form input[placeholder], #tee-artwork-form textarea[placeholder]').forEach(input => {
      const translation = labels.get(input.getAttribute('placeholder').trim());
      if (translation) input.setAttribute('placeholder', translation);
    });
  }
  const observer = new MutationObserver(mutations => {
    if (!scheduled && mutations.some(mutation =>
      mutation.target.nodeType === 1 &&
      (mutation.target.closest?.('#tee-artwork-form, .tee-quantity, .tee-product-price') ||
        Array.from(mutation.addedNodes).some(node => node.nodeType === 1 &&
          (node.matches?.('#tee-artwork-form, .tee-quantity, .tee-product-price') || node.querySelector?.('#tee-artwork-form, .tee-quantity, .tee-product-price'))))
    )) {
      scheduled = true;
      requestAnimationFrame(translateLabels);
    }
  });
  function init() {
    translateLabels();
    observer.observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


